import { Badge, InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSearchTerm } from './SearchContext';
import { Close } from '@mui/icons-material';

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 8px;
`

const CloseButton = styled(Close)`
  cursor: pointer;
`

const SearchField = () => {
  const { searchTerm, setSearchTerm, foundItems } = useSearchTerm()
  const foundCount = foundItems && Object.keys(foundItems).length
  const [search, setSearch] = useState()

  const handleChange = useCallback((event) => {
    setSearch(event.target.value)
  }, [])

  const handleClearSearch = useCallback(() => {
    setSearch(false)
  }, [])

  useEffect(() => {
    setSearch(searchTerm?.term || false)
  }, [searchTerm?.term])

  useEffect(() => {
    if (search !== searchTerm?.term) {
      const timer = setTimeout(() => {
        setSearchTerm({ term: search })
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [search, searchTerm?.term, setSearchTerm])

  return (
    <Container>
      <TextField
        fullWidth={true}
        size="small"
        label="Search"
        variant="outlined"
        value={search || ''}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {foundCount > 0 &&
                <Badge badgeContent={foundCount} color="primary">
                  <CloseButton onClick={handleClearSearch} />
                </Badge>
              }
            </InputAdornment>
          )
        }}
        onChange={handleChange}
      />
    </Container>
  )
}

export default SearchField
